import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components'
import { Button } from '@hhgtech/hhg-components/mantine'

export const StyledBuyNowButtons = styled.div`
  display: grid;
  gap: 8px;
  &[data-more] {
    transition: max-height 0.6s;
    max-height: 0;
    overflow: hidden;
    margin-top: 8px;
  }
  &[data-show-all='true'] {
    max-height: 400px;
  }
  &[data-size='auto'] {
    // grid-template-columns: repeat(4, 1fr);
    // ${MediaQueries.mbDown} {
    grid-template-columns: repeat(2, 1fr);
    &[data-one='true'] {
      grid-template-columns: 1fr;
    }
    // }
  }
  &[data-size='sm'] {
    grid-template-columns: repeat(2, 1fr);
    &[data-one='true'] {
      grid-template-columns: 1fr;
    }
  }
  &[data-size='lg'] {
    grid-template-columns: repeat(4, 1fr);
  }
`

export const StyledBuyNowItem = styled.a`
  display: flex;
  text-decoration: none;
  padding: 6px;
  align-items: center;
  gap: 8px;
  border: 1px solid ${theme.colors.blue100};
  border-radius: 8px;
  &:hover,
  &:active,
  &:focus {
    background-color: ${theme.colors.blue100};
    border-color: ${theme.colors.primaryBase};
  }
  .info-text {
    display: flex;
    flex-direction: column;
    .price-text {
      display: flex;
      align-items: center;
    }
    svg,
    img {
      margin-left: 4px;
    }
    img {
      object-fit: cover;
      border-radius: 4px;
    }
    svg path {
      fill: ${theme.colors.red800};
    }
  }
`

export const StyledSeeMoreButton = styled(Button)`
  &[data-show='true'] {
    margin-top: 0px;
  }
  > span {
    display: inline-flex;
    align-items: center;
  }
  margin-top: -8px;
  color: ${theme.colors.primaryBase};
  svg[data-show='true'] {
    transform: rotate(-90deg);
  }
  svg path {
    fill: ${theme.colors.primaryBase};
  }
  &[data-display-size='auto'] {
    ${MediaQueries.mbUp} {
      padding-left: 6px;
    }
    ${MediaQueries.mbDown} {
      width: 100%;
    }
  }
  &[data-display-size='sm'] {
    width: 100%;
  }
  &[data-display-size='lg'] {
    padding-left: 6px;
  }
`
